import { create } from 'zustand'

interface MouseState {
  mousePosition: { x: number; y: number }
  handleMouseMove: (event: MouseEvent) => void
}

export const mouseStore = create<MouseState>((set) => ({
  mousePosition: { x: 0, y: 0 },
  handleMouseMove: (event: MouseEvent) => {
    set({ mousePosition: { x: event.clientX, y: event.clientY } })
  },
}))

export function useMousePosition() {
  const { mousePosition, handleMouseMove } = mouseStore()
  return { mousePosition, handleMouseMove }
}
